import styled from 'styled-components'

export const ProductPrice = styled.p`
font-family: 'SF UI Text', sans-serif;
font-weight: 400;
font-size: 3.75rem;
line-height: 160%;
text-align: center;

margin-bottom: 3rem;

@media (min-width: 1300px) {
    text-align: left;
}

`
